import { render, staticRenderFns } from "./BorderedFieldset.vue?vue&type=template&id=5dbe5a5e&scoped=true&"
import script from "./BorderedFieldset.vue?vue&type=script&lang=js&"
export * from "./BorderedFieldset.vue?vue&type=script&lang=js&"
import style0 from "./BorderedFieldset.vue?vue&type=style&index=0&id=5dbe5a5e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dbe5a5e",
  null
  
)

export default component.exports